<template>
  <v-div
    v-if="shouldShow"
    class="FundingInformation"
    border-inverted-bottom-thick
    mt-3
    px-2
  >
    <h2 class="ml-2 font-weight-bold font-smaller">Funding</h2>
    <v-div
      v-for="(funder, index) in article.funders"
      :key="funder.funderId"
      font-smaller
      :border-inverted-top="index > 0"
      mb-3
      pt-2
      px-2
    >
      <v-div
        v-if="funder.name"
        rounded
        d-inline-block
        pl-3
        pr-3
        background-inverted
        foreground-primary
        text-center
        font-small
      >
        <strong>{{ funder.name }}</strong>
      </v-div>
      <v-div v-if="funder.grantNumber" caption mt-1 text-truncate>{{
        funder.grantNumber
      }}</v-div>
      <v-div v-if="funder.title" caption mt-1>{{ funder.title }}</v-div>
      <v-div v-if="funder.url" font-smaller>
        <a :href="funder.url" target="_blank">
          {{ funder.url }}
          <span class="d-sr-only">[opens in a new tab]</span>
          <v-icon small color="primary" aria-hidden="true">{{
            mdiOpenInNew
          }}</v-icon>
        </a>
      </v-div>
    </v-div>
  </v-div>
</template>

<script>
import { mdiOpenInNew } from "@mdi/js";
export default {
  name: "FundingInformation",
  props: {
    article: { type: Object, required: true },
  },
  data() {
    return {
      mdiOpenInNew,
    };
  },
  computed: {
    shouldShow() {
      const { article = {} } = this;
      const { funders = [] } = article;

      return funders.length > 0;
    },
  },
};
</script>

<style>
.FundingInformation {
  word-break: break-word;
}
</style>
